import { SessionService } from './session.service';
import { Http, Headers, RequestOptionsArgs } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class BqsService {

    private baseUri: string = 'api/Bqs/';

    constructor(private http: Http, private session: SessionService) { }

    public getStandardCreditInfoPDF() {
        return this.http.get(this.baseUri + 'GetStandardCreditInfoPDF', this.getSessionGuidHeaders())
            .map((resp) => resp.json().StandardCreditInfoPdf);
    }

    public getAgreement() {
        return this.http.get(this.baseUri + 'GetAgreement', this.getSessionGuidHeaders())
            .map((resp) => resp.json());
    }

    public createAccountApplication(ssno: string, phone: string, email: string, mobilesign: boolean) {
        return this.http.post(this.baseUri + 'CreateAccountApplication', {
            ssno,
            email,
            phone,
            mobilesign
        }, this.getSessionGuidHeaders())
            .map((resp) => resp.json());
    }

    public completeAccountApplication(contractNumber: string, creditCheckReference: string, documentId: string) {
        return this.http.post(this.baseUri + 'CompleteAccountApplication', {
            contractNumber,
            creditCheckReference,
            documentId
        }, this.getSessionGuidHeaders())
            .map((resp) => resp.json());
    }

    public abortAccountApplication(contractNumber: string, creditCheckReference: string) {
        return this.http.post(this.baseUri + 'AbortAccountApplication', {
            contractNumber,
            creditCheckReference
        }, this.getSessionGuidHeaders())
            .map((resp) => resp.json());
    }

    private getSessionGuidHeaders(): RequestOptionsArgs {
        let headers = new Headers();
        headers.append('Session', this.session.guid);
        return { headers };
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Service/bqs.service.ts
 **/